import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {

  getRangeLabel = function (page, pageSize, length) {
    return `Page ${page + 1}`;
  };
}
